<template>
  <transition name="modal">
    <v-modal
      v-cloak
      :show-close-button="!isConfirmSaveProposal"
      :is-open="showModal"
      :disable-close-button="loading"
      @close="$store.dispatch('policy/closeModal')"
    >
      <template #title>
        <h1 v-if="isConfirmSaveProposal" v-html="modalData.title" />
        <h3 v-else v-html="modalData.title" />
      </template>
      <template #content>
        <div v-if="isConfirmSaveProposal">
          <confirm-save-proposal-modal-content />
        </div>
        <div v-else v-html="modalData.content" />
      </template>
      <template #buttons>
        <div>
          <modal-buttons :buttons="modalData.buttons" :loading="loading" />
        </div>
      </template>
      <template #footer />
    </v-modal>
  </transition>
</template>
<script>
import ConfirmSaveProposalModalContent from './Modals/ConfirmSaveProposalModalContent.vue';
import ModalButtons from '@/components/UI/ModalButtons.vue';
import { hasPropertyDeep } from '@/common/Util/utility';

export default {
  name: 'PolicyModal',
  components: {
    ConfirmSaveProposalModalContent,
    ModalButtons
  },
  computed: {
    modalData() {
      return this.$store.state.policy.modalData;
    },
    showModal() {
      return this.$store.state.policy.showModal;
    },
    isConfirmSaveProposal() {
      return (
        hasPropertyDeep(this.modalData, 'name') && this.modalData.name === 'confirmSaveProposal'
      );
    },
    loading() {
      return this.$store.state.policy.loading;
    }
  }
};
</script>
